import store from 'src/vuex'
import { ROLES_PERMISSIONS } from './roles-permissions'

const userHasPermission = (permission) => {
  const userPermissions = store.state.auth.user.permissions
  return userPermissions.includes(permission)
}

const hasPermission = () => {
  return {
    //BOTS
    activateBot: userHasPermission(ROLES_PERMISSIONS.BOT.ACTIVATE_BOT),
    //COMPANIES
    activateCompany: userHasPermission(
      ROLES_PERMISSIONS.COMPANIES.ACTIVATE_COMPANY
    ),
    activateProduct: userHasPermission(
      ROLES_PERMISSIONS.COMPANIES.ACTIVATE_PRODUCT
    ),
    addAccountStatements: userHasPermission(
      ROLES_PERMISSIONS.COMPANIES.ADD_ACCOUNT_STATEMENTS
    ),
    addBankAccounts: userHasPermission(
      ROLES_PERMISSIONS.COMPANIES.ADD_BANK_ACCOUNTS
    ),
    addTradingAccounts: userHasPermission(
      ROLES_PERMISSIONS.COMPANIES.ADD_TRADING_ACCOUNTS
    ),
    changeAccountState: userHasPermission(
      ROLES_PERMISSIONS.COMPANIES.CHANGE_ACCOUNT_STATE
    ),
    changeCompanyGrades: userHasPermission(
      ROLES_PERMISSIONS.COMPANIES.CHANGE_COMPANY_GRADES
    ),
    commentCompany: userHasPermission(
      ROLES_PERMISSIONS.COMPANIES.COMMENT_COMPANY
    ),
    deactivateCompany: userHasPermission(
      ROLES_PERMISSIONS.COMPANIES.DEACTIVATE_COMPANY
    ),
    deactivateProduct: userHasPermission(
      ROLES_PERMISSIONS.COMPANIES.DEACTIVATE_PRODUCT
    ),
    editCompanyContacts: userHasPermission(
      ROLES_PERMISSIONS.COMPANIES.EDIT_COMPANY_CONTACTS
    ),
    editCompanyPricing: userHasPermission(
      ROLES_PERMISSIONS.COMPANIES.EDIT_COMPANY_PRICING
    ),
    editCompanyConfig: userHasPermission(
      ROLES_PERMISSIONS.COMPANIES.EDIT_COMPANY_CONFIG
    ),
    editTradingAccounts: userHasPermission(
      ROLES_PERMISSIONS.COMPANIES.EDIT_TRADING_ACCOUNTS
    ),
    readCompany: userHasPermission(ROLES_PERMISSIONS.COMPANIES.READ_COMPANIES),
    readCompanyConfig: userHasPermission(
      ROLES_PERMISSIONS.COMPANIES.READ_COMPANY_CONFIG
    ),
    readCompanyContacts: userHasPermission(
      ROLES_PERMISSIONS.COMPANIES.READ_COMPANY_CONTACTS
    ),
    suspendCompany: userHasPermission(
      ROLES_PERMISSIONS.COMPANIES.SUSPEND_COMPANY
    ),
    unsuspendCompany: userHasPermission(
      ROLES_PERMISSIONS.COMPANIES.UNSUPEND_COMPANY
    ),
    editFinancingIndicator: userHasPermission(
      ROLES_PERMISSIONS.COMPANIES.EDIT_FINANCING_INDICATOR
    ),
    runCompanyChecks: userHasPermission(
      ROLES_PERMISSIONS.COMPANIES.RUN_COMPANY_CHECKS
    ),
    //CREDIT NOTES
    readCreditNote: userHasPermission(
      ROLES_PERMISSIONS.CREDIT_NOTE.READ_CREDIT_NOTE
    ),
    //DEBT COLLECTION
    editDCCases: userHasPermission(
      ROLES_PERMISSIONS.DEBT_COLLECTION.EDIT_DC_CASES
    ),
    readDCCases: userHasPermission(
      ROLES_PERMISSIONS.DEBT_COLLECTION.READ_DC_CASES
    ),
    readDCFlows: userHasPermission(
      ROLES_PERMISSIONS.DEBT_COLLECTION.READ_DC_FLOWS
    ),
    //ETRS
    approveEtr: userHasPermission(ROLES_PERMISSIONS.ETR.APPROVE_ETRS),
    cancelEtr: userHasPermission(ROLES_PERMISSIONS.ETR.CANCEL_ETRS),
    readEtr: userHasPermission(ROLES_PERMISSIONS.ETR.READ_ETRS),
    downloadETRCertificates: userHasPermission(
      ROLES_PERMISSIONS.ETR.DOWNLOAD_ETRS_CERTIFICATES
    ),
    //ETPS
    readEtp: userHasPermission(ROLES_PERMISSIONS.ETP.READ),
    cancelEtp: userHasPermission(ROLES_PERMISSIONS.ETP.CANCEL),
    defaultEtp: userHasPermission(ROLES_PERMISSIONS.ETP.DEFAULT),
    placeEtpOrder: userHasPermission(ROLES_PERMISSIONS.ETP.PLACE_ORDER),
    writeOffEtp: userHasPermission(ROLES_PERMISSIONS.ETP.WRITE_OFF),
    //PAYABLES
    readPayables: userHasPermission(ROLES_PERMISSIONS.PAYABLE.READ),
    approvePayables: userHasPermission(ROLES_PERMISSIONS.PAYABLE.APPROVE),
    rejectPayables: userHasPermission(ROLES_PERMISSIONS.PAYABLE.REJECT),
    //INVESTORS
    activateStrategy: userHasPermission(
      ROLES_PERMISSIONS.INVESTORS.ACTIVATE_STRATEGY
    ),
    editStrategies: userHasPermission(
      ROLES_PERMISSIONS.INVESTORS.EDIT_STRATEGIES
    ),
    readStrategies: userHasPermission(
      ROLES_PERMISSIONS.INVESTORS.READ_STRATEGIES
    ),
    //INVOICES
    approveInvoice: userHasPermission(
      ROLES_PERMISSIONS.INVOICE.APPROVE_INVOICE
    ),
    commentInvoice: userHasPermission(
      ROLES_PERMISSIONS.INVOICE.COMMENT_INVOICE
    ),
    exportInvoice: userHasPermission(ROLES_PERMISSIONS.INVOICE.EXPORT_INVOICE),
    pendingInvoice: userHasPermission(
      ROLES_PERMISSIONS.INVOICE.PENDING_INVOICE
    ),
    sellInvoice: userHasPermission(ROLES_PERMISSIONS.INVOICE.SELL_INVOICE),
    readInvoice: userHasPermission(ROLES_PERMISSIONS.INVOICE.READ_INVOICE),
    recheckInvoice: userHasPermission(
      ROLES_PERMISSIONS.INVOICE.RECHECK_INVOICE
    ),
    rejectInvoice: userHasPermission(ROLES_PERMISSIONS.INVOICE.REJECT_INVOICE),
    uploadInvoice: userHasPermission(ROLES_PERMISSIONS.INVOICE.UPLOAD_INVOICE),
    writeOffInvoice: userHasPermission(
      ROLES_PERMISSIONS.INVOICE.WRITE_OFF_INVOICE
    ),
    //LEADS
    createLeads: userHasPermission(ROLES_PERMISSIONS.LEADS.CREATE_LEADS),
    approveLeads: userHasPermission(ROLES_PERMISSIONS.LEADS.APPROVE_LEADS),
    commentLeads: userHasPermission(ROLES_PERMISSIONS.LEADS.COMMENT_LEADS),
    readLeads: userHasPermission(ROLES_PERMISSIONS.LEADS.READ_LEADS),
    rejectLeads: userHasPermission(ROLES_PERMISSIONS.LEADS.REJECT_LEADS),
    resetLeads: userHasPermission(ROLES_PERMISSIONS.LEADS.RESET_LEADS),
    //MARKET
    activateMarkets: userHasPermission(
      ROLES_PERMISSIONS.MARKET.ACTIVATE_MARKETS
    ),
    createOrder: userHasPermission(ROLES_PERMISSIONS.MARKET.CREATE_ORDER),
    readMarkets: userHasPermission(ROLES_PERMISSIONS.MARKET.READ_MARKETS),
    //MATCHING
    addComments: userHasPermission(ROLES_PERMISSIONS.MATCHING.ADD_COMMENTS),
    forwardPayment: userHasPermission(
      ROLES_PERMISSIONS.MATCHING.FORWARD_PAYMENT
    ),
    readMatchingPayments: userHasPermission(
      ROLES_PERMISSIONS.MATCHING.READ_MATCHING_PAYMENTS
    ),
    resolvePayment: userHasPermission(
      ROLES_PERMISSIONS.MATCHING.RESOLVE_PAYMENT
    ),
    settle: userHasPermission(ROLES_PERMISSIONS.MATCHING.SETTLE),
    unmatchPayment: userHasPermission(
      ROLES_PERMISSIONS.MATCHING.UNMATCH_PAYMENT
    ),
    //PARTNERS
    createPartner: userHasPermission(ROLES_PERMISSIONS.PARTNERS.CREATE_PARTNER),
    editPartner: userHasPermission(ROLES_PERMISSIONS.PARTNERS.EDIT_PARTNER),
    editPartnerPricing: userHasPermission(
      ROLES_PERMISSIONS.PARTNERS.EDIT_PARTNER_PRICING
    ),
    readPartners: userHasPermission(ROLES_PERMISSIONS.PARTNERS.READ_PARTNERS),
    //PRICING
    readPricing: userHasPermission(ROLES_PERMISSIONS.INVESTORS.READ_PRICING),
    editPricing: userHasPermission(ROLES_PERMISSIONS.INVESTORS.EDIT_PRICING),
    //POSITIONS
    readPositions: userHasPermission(
      ROLES_PERMISSIONS.INVESTORS.READ_POSITIONS
    ),
    //ACCOUNT STATEMENTS
    readAccountStatements: userHasPermission(
      ROLES_PERMISSIONS.INVESTORS.READ_ACCOUNT_STATEMENTS
    ),
    //SETTLEMENT-LOCK
    acceptSettlementLock: userHasPermission(
      ROLES_PERMISSIONS.SETTLEMENT_LOCK.ACCEPT_SETTLEMENT_LOCK
    ),
    keepProceedsSettlementLock: userHasPermission(
      ROLES_PERMISSIONS.SETTLEMENT_LOCK.KEEP_PROCEEDS_SETTLEMENT_LOCK
    ),
    readSettlementLock: userHasPermission(
      ROLES_PERMISSIONS.SETTLEMENT_LOCK.READ_SETTLEMENT_LOCK
    ),
    rejectSettlementLock: userHasPermission(
      ROLES_PERMISSIONS.SETTLEMENT_LOCK.REJECT_SETTLEMENT_LOCK
    ),
    //TRADES
    acceptTradeLock: userHasPermission(
      ROLES_PERMISSIONS.TRADES.ACCEPT_TRADE_LOCK
    ),
    keepProceedsTradeLock: userHasPermission(
      ROLES_PERMISSIONS.TRADES.KEEP_PROCEEDS_TRADE_LOCK
    ),
    readTradeLock: userHasPermission(ROLES_PERMISSIONS.TRADES.READ_TRADE_LOCK),
    rejectTradeLock: userHasPermission(
      ROLES_PERMISSIONS.TRADES.REJECT_TRADE_LOCK
    ),
    //ROLE-MANAGEMENT
    readPermission: userHasPermission(
      ROLES_PERMISSIONS.ROLE_MANAGEMENT.READ_PERMISSION
    ),
    createPermission: userHasPermission(
      ROLES_PERMISSIONS.ROLE_MANAGEMENT.CREATE_PERMISSION
    ),
    editRolePermission: userHasPermission(
      ROLES_PERMISSIONS.ROLE_MANAGEMENT.EDIT_ROLE_PERMISSION
    ),
    readRole: userHasPermission(ROLES_PERMISSIONS.ROLE_MANAGEMENT.READ_ROLE),
    createRole: userHasPermission(
      ROLES_PERMISSIONS.ROLE_MANAGEMENT.CREATE_ROLE
    ),
    editRole: userHasPermission(ROLES_PERMISSIONS.ROLE_MANAGEMENT.EDIT_ROLE)
  }
}
export default {
  hasPermission
}
